import { SVGProps } from 'react';

const Mars = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 8V3h-5m5 0-6.75 6.75M16 14a6 6 0 1 1-12 0 6 6 0 0 1 12 0"
    />
  </svg>
);
export default Mars;
